var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-card rb white-txt",class:_vm.color},[_c('div',{staticClass:"stat"},[_c('growing-number',{attrs:{"value":_vm.statNumber}})],1),_c('div',{staticClass:"stat-one"},[_c('div',{staticClass:"component-header"},[_vm._v(_vm._s(_vm.statTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }